<template>
	<div class="container">
		<div class="row">
			<div class="form-container">
				<h2 class="title-center header-no-padding-bottom">Login</h2>
				<div class="col-sm-6 col-sm-offset-3">
					<login></login>
				</div>
			</div>
		</div>
	</div>
</template>

<style scoped>
	h2{
		padding-bottom: 0;
	}
</style>

<script>
import Login from '../components/Login.vue';

export default{
	components:{
		Login,
	}
}
</script>


// WEBPACK FOOTER //
// Login.vue?6b061b40